exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol.breadcrumb {\n  font-size: 12px;\n  background-color: #ffffff !important;\n  border: 0px solid white !important;\n}\n.breadcrumb-item a {\n  color: black;\n}\n.breadcrumb-item .text-item-icon {\n  margin-right: 2px;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  content: \">\";\n}\n", ""]);

// exports
